import * as React from 'react';
import {connect} from 'react-redux';

import * as ramda from 'ramda';

import {convertToArray} from 'nutshell-core/filter';

import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {makeHandleClickChartToZoom} from '../../../reports/charts/make-handle-click-chart-to-zoom';
import {ReportChart} from '../../../reports/report-chart';
import {
    EDITION_GAP_SELECT_VALUES,
    EDITION_GAP_INITIAL_VALUES,
    getReportDateRanges,
} from '../../../reports/report-constants';
import {ReportDateRangePicker} from '../../../reports/report-date-range-picker';
import {ReportDateRangePickerSimple} from '../../../reports/report-date-range-picker-simple';
import type {ReportURLParams} from '../../../reports/report-types';
import * as reportSelectors from '../../../reports/reports-selectors';

import type {NutshellState} from '../../../../store';

import type {EditionEngagementChartParams} from '../edition-utils';
import * as actions from '../editions-actions';

import {EditionEngagementReportProvider} from './edition-engagement-report-provider';

import styles from './edition-engagement-report.module.css';

type OwnProps = {
    edition: Edition;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
};

type StateProps = {
    chartBucketCount: number;
};

type DispatchProps = {
    fetchReportData: (arg1: EditionEngagementChartParams, arg2: any[]) => any;
};

type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        chartBucketCount: reportSelectors.getCurrentReportChartBucketCount(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch) {
    return {
        // @ts-expect-error
        fetchReportData: (reportParams, filters) => {
            dispatch(actions.requestEditionEngagementReportData({reportParams, filters}));
        },
    };
}

class EditionEngagementReportComponent extends React.PureComponent<Props> {
    static defaultProps = {
        urlParams: {
            report: {},
            filter: {},
        },
    };

    componentDidMount() {
        const filters = convertToArray(this.props.urlParams.filter);
        const reportParams = this.props.urlParams.report;

        this.props.fetchReportData(
            {
                ...reportParams,
                editionId: this.props.edition.id,
            },
            filters
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const {
            urlParams: {report: nextReportParams, filter: nextFilterParams},
        } = nextProps;

        const {
            urlParams: {report: reportParams, filter: filterParams},
            edition,
        } = this.props;

        const filtersChanged = !ramda.equals(nextFilterParams, filterParams);
        const gapChanged = nextReportParams.gap !== reportParams.gap;
        const editionChanged = nextProps.edition.id !== edition.id;

        const universalPropsChanged = filtersChanged;

        if (gapChanged || universalPropsChanged || editionChanged) {
            const nextFilters = convertToArray(nextFilterParams);
            this.props.fetchReportData(
                {
                    ...nextReportParams,
                    editionId: nextProps.edition.id,
                },
                nextFilters
            );
        }
    }

    render() {
        const reportParams = this.props.urlParams.report || {};
        const currentGapIndex = EDITION_GAP_SELECT_VALUES.findIndex((gap) => {
            return gap.id === reportParams.gap;
        });
        const isDripEditionReport = this.props.edition.campaign.type === 'DRIP_SEQUENCE';

        const PickerComponent = isDripEditionReport
            ? ReportDateRangePicker
            : ReportDateRangePickerSimple;

        return (
            <div id='edition-engagement-report' className={styles['edition-engagement-report']}>
                <PickerComponent
                    activeFilters={convertToArray(this.props.urlParams.filter)}
                    dateRangeType='period'
                    // @ts-expect-error
                    dateRangeOptions={
                        isDripEditionReport
                            ? getReportDateRanges('dripEditionEngagement')
                            : getReportDateRanges('editionEngagement')
                    }
                    onDateRangeChange={(newFilter) => {
                        let newParams = {filter: newFilter};

                        const initialGap = EDITION_GAP_INITIAL_VALUES.find(
                            (init) => init.period === newFilter.period
                        );
                        if (initialGap) {
                            newParams = {
                                ...newParams,
                                // @ts-expect-error
                                report: {
                                    gap: initialGap.gap,
                                },
                            };
                        }
                        this.props.onParamChange(newParams, true);
                    }}
                />
                <EditionEngagementReportProvider>
                    <ReportChart
                        hasBorder={true}
                        activeFilters={convertToArray(this.props.urlParams.filter)}
                        // @ts-expect-error
                        onChartClick={makeHandleClickChartToZoom(
                            currentGapIndex,
                            this.props.chartBucketCount,
                            this.props.onParamPush,
                            this.props.urlParams.report.dateRangeType
                        )}
                        height={475}
                        onParamChange={this.props.onParamChange}
                        reportKey={
                            isDripEditionReport ? 'dripEditionEngagement' : 'editionEngagement'
                        }
                        reportParams={reportParams}
                        xAxisLabel='Date'
                    />
                </EditionEngagementReportProvider>
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
// @ts-expect-error
export const EditionEngagementReport = connector(EditionEngagementReportComponent);
